export class UserPrivateAccountStorage {
  static instance;

  constructor() {
    if (UserPrivateAccountStorage.instance) {
      throw new Error('Clase singleton')
    }
  }

  static getInstance() {
    if (!UserPrivateAccountStorage.instance) {
      UserPrivateAccountStorage.instance = new UserPrivateAccountStorage();
    }
    return UserPrivateAccountStorage.instance;
  }

  _emptyPlan() {
    return {
      status: 0,
      planTitle: 'Plan Gratuito',
      planIdcod: 0
    }
  }

  planSave(_plan) {
    try {
      let plan = JSON.stringify(_plan);
      window.localStorage.setItem('user-plan', plan);
    } catch (error) {
      let plan = this._emptyPlan();
      window.localStorage.setItem('user-plan', JSON.stringify(plan));
    }
  }

  planRead() {
    let plan = window.localStorage.getItem('user-plan');

    try {
      plan = JSON.parse(plan);
      return plan;
    } catch (error) {
      return this._emptyPlan();
    }
  }

  clear() {
    this.planSave(this._emptyPlan());
  }

  setPublishLimit(_max) {
    if (Number(_max)) {
      window.localStorage.setItem('limit', _max);
    }
  }

  getPublishLimit(_max) {
    return Number(window.localStorage.getItem('limit')) || 4;
  }
}
